export default __webpack_public_path__ + "static/media/people-following-plant-based-diet-in-europe.abb9e47c.png";